import React, { useEffect, useState, useRef, Suspense, lazy } from "react";
import clsx from "clsx";
// eslint-disable-next-line import/no-cycle
import { Share, DonationFeedBanner } from "@molecules";
import { Twitch, Text, Button, ButtonAlt, Icon } from "@atoms";
import Widgetbot from "@widgetbot/react-embed";

const Video = lazy(() => import("../atoms/Video"));

const Stream = ({
  twitchChannel,
  heading,
  copy,
  button,
  links,
  // share,
  // imagePlaceholder,
  placeholderVideo: videoPlaceholder,
  aspectRatio,
  historySection,
  widget,
  url,
  live,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [showWidget, setShowWidget] = useState(false);
  const embed = useRef();

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <>
      {live && loaded && (
        <div className="fixed bottom-0 right-0 z-30 p-3">
          <div className="relative">
            <Button
              color="white"
              type="button"
              size="xs"
              onClick={() => setShowWidget(true)}
            >
              <Icon name="chat" className="h-8 w-8" fitHeight />
            </Button>
            <div
              ref={widget}
              className={clsx(
                "absolute bottom-0 right-0 z-0 overflow-hidden transition-all duration-200",
                {
                  "z-10 h-[525px] w-[325px] lg:h-[600px] lg:w-[400px]":
                    showWidget,
                  "z-0 h-0 w-0": !showWidget,
                }
              )}
            >
              <div className="widgetbot relative z-0 h-full w-full">
                {typeof window !== "undefined" && (
                  <Widgetbot server={widget.server} channel={widget.channel} />
                )}
              </div>{" "}
              <button
                type="button"
                className={clsx(
                  "absolute right-0 top-0 bg-red p-1 text-white transition duration-200",
                  { "opacity-0": !showWidget }
                )}
                onClick={() => setShowWidget(false)}
              >
                <Icon name="close" className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        ref={embed}
        className="relative w-full bg-black"
        style={{ paddingBottom: "56.25%" }}
      >
        <div className="absolute inset-0 overflow-hidden">
          {live && (
            <Twitch
              videoPlaceholder={videoPlaceholder}
              channel={twitchChannel}
              layout="video"
              muted
            />
          )}
          {!live && typeof window !== "undefined" && (
            <Suspense fallback={<div />}>
              <Video url={videoPlaceholder} aspectRatio={aspectRatio} />
            </Suspense>
          )}
        </div>
      </div>
      <div>
        <DonationFeedBanner />
      </div>
      {/* stream details */}
      <div className="relative flex-grow bg-white p-6">
        <Text variant="h4">{heading}</Text>
        <Text variant="body" className="mt-4">
          {copy}
        </Text>
        <div className="mt-6 flex w-full flex-col flex-wrap items-start space-y-3 sm:flex-row sm:items-center sm:space-x-6 sm:space-y-0">
          <Button to={button.url} size="sm">
            {button.text}
          </Button>
          {links?.map((link, i) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <ButtonAlt key={i} to={link.url}>
                {link.text}
              </ButtonAlt>
            );
          })}
          <ButtonAlt
            onClick={() => {
              historySection.scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            About Us
          </ButtonAlt>
        </div>
        <div className="mt-3">
          <Share
            links
            cta="Invite Friends &amp; Family"
            compact
            small
            dark
            url={url}
            intent="homepage"
          />
        </div>
      </div>
    </>
  );
};

Stream.defaultProps = {};

export default Stream;
